<template>
  <div id="app" v-on:click="newRandomColorClick" v-bind:style="{'background-color': bgcolor, '--c-background': bgcolor, '--c-background-contrast': bgcolorcontrast}">
    <Title v-bind:title="color.name" v-bind:color="color.hex"/>
  </div>
</template>

<script>
import 'reset-css';
import chroma from 'chroma-js';
import Title from './components/Title.vue';

export default {
  name: 'app',
  components: {
    Title
  },
  data: function(){
    return {
      color: {
        name: 'color.pizza',
        hex: 'served soon',
      },
      bgcolor: '#212121',
    }
  },
  mounted() {
    this.changeFavicon();
    this.interval = setInterval(this.newRandomColor, 10000);
  },
  methods: {
    changeFavicon: function() {
      const $favicon = document.querySelector('[rel="icon"]');
      const faviconSize = 98;

      const canvas = document.createElement('canvas');
      canvas.width = faviconSize;
      canvas.height = faviconSize;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = this.bgcolor;
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(0,0);
      ctx.lineTo(98,0);
      ctx.lineTo(98,98);
      ctx.lineTo(0,98);
      ctx.closePath();
      ctx.clip();
      ctx.translate(0,0);
      ctx.translate(0,0);
      ctx.scale(1,1);
      ctx.translate(0,0);
      ctx.save();
      ctx.restore();
      ctx.save();
      ctx.translate(-1,-1);
      ctx.beginPath();
      ctx.moveTo(83.57,14.32);
      ctx.lineTo(50.77,50.77);
      ctx.lineTo(50.77,1);
      ctx.lineTo(50,1);
      ctx.translate(49.98521536222182,49.99999776953551);
      ctx.rotate(0);
      ctx.scale(1,1);
      ctx.arc(0,0,49,-1.5704945994887232,-7.098823577516132,1);
      ctx.scale(1,1);
      ctx.rotate(0);
      ctx.translate(-49.98521536222182,-49.99999776953551);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
      ctx.restore();
      
      
      // Replace favicon
      $favicon.href = canvas.toDataURL('image/png');
    },
    newRandomColorClick: function() {
      window.clearInterval(this.interval);
      this.newRandomColor();
    },
    newRandomColor: function() {
      this.getColorName(Math.random().toString(16).slice(2, 8));
    },
    getColorName: function(hex) {
      fetch('https://api.color.pizza/v1/' + hex.replace('#', '')).then(data => data.json()).then(data => {
        this.color = data.colors[0];
        this.bgcolor = this.color.hex;
        this.changeFavicon();
      });
    }
  },
  computed: {
    bgcolorcontrast: function () {
      return chroma.contrast(this.bgcolor, '#ffffff') > chroma.contrast(this.bgcolor, '#212121') ? '#ffffff' : '#212121';  
    }
  }
}
</script>

<style>
@import url('https://rsms.me/inter/inter.css');

:root {
  --c-black: #212121;
  --c-white: #fff;
  
  --c-background: var(--c-black);
  --c-background-contrast: var(--c-white);

  --s-bezel: 2rem;
  
  --font: 'Inter', sans-serif; 
  
  font-size: calc(.6rem + .4vw);

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background: var(--c-background);
  user-select: none;
}

@supports (font-variation-settings: normal) {
  :root { --font: 'Inter var', sans-serif; }
}

:root {
  font-family: var(--font);
  font-feature-settings: "dlig" 0, "numr" 0, "dnom" 0, "tnum" , "case" 0, "zero" 0, "frac", "sups" 0, "subs" 0, "cpsp" 0, "salt" 0, "ss01", "ss02" 0, "cv01" 0, "cv02" 0, "cv03" 0, "cv04" 0, "cv05" 0, "cv06" 0, "cv07" 0, "cv08" 0, "cv09" 0, "cv10" 0, "calt", "liga", "kern";
}
#app, body {
  min-height: 100vh;
  cursor: pointer;
  transition: 333ms color, 333ms background-color; 
}

</style>
